import { isAxiosError } from "axios"
import { BATTLE_DENIAL_REASON } from "@/store/apis/battleAPI/battle.types"
import { MOB_ACTION_DENIAL_REASON } from "@/store/apis/mobsAPI/mobs.types"

export type IAttackRefusalReason =
  | MOB_ACTION_DENIAL_REASON.NO_FREE_MOB
  | MOB_ACTION_DENIAL_REASON.PLAYER_MOVING
  | MOB_ACTION_DENIAL_REASON.NOT_ON_CELL
  | MOB_ACTION_DENIAL_REASON.ENGAGEMENT_OPEN
  | BATTLE_DENIAL_REASON.HP_TOO_LOW

export type IAttackOutcome = IAttackRefusalReason | "FAILED"

export type IAttackRefusal = Exclude<
  IAttackOutcome,
  MOB_ACTION_DENIAL_REASON.ENGAGEMENT_OPEN
>

const ATTACK_REFUSALS: readonly IAttackRefusalReason[] = [
  MOB_ACTION_DENIAL_REASON.NO_FREE_MOB,
  MOB_ACTION_DENIAL_REASON.PLAYER_MOVING,
  MOB_ACTION_DENIAL_REASON.NOT_ON_CELL,
  MOB_ACTION_DENIAL_REASON.ENGAGEMENT_OPEN,
  BATTLE_DENIAL_REASON.HP_TOO_LOW
]

export const attackRefusalOf = (error: unknown): IAttackOutcome => {
  if (
    !isAxiosError<{ reason?: string }>(error) ||
    error.response?.status !== 409
  ) {
    return "FAILED"
  }
  const reason = error.response.data?.reason
  return ATTACK_REFUSALS.find((refusal) => refusal === reason) ?? "FAILED"
}
